"use client";

import {
    useEffect,
    useState
} from "react";
import {
    getSession,
    signIn,
    useSession
} from "next-auth/react";
import { useTranslations } from "next-intl";
import { isJsonString } from "@/lib/utils";
import {
    Button,
    Form,
    Input
} from 'antd';
import { useRouter } from "@/navigation";
import { myLinks } from "@/lib/routes/myLinks";
import { api } from "@/lib/api/api";
import { useNotification } from "@/lib/hook";
import s from './auth.module.scss'
import {
    Logo,
    MyForm,
    Link,
    LanguagesSwitch
} from '@/theme/ui';

export default function SignIn() {
    const t = useTranslations('login');
    const tValid = useTranslations('validation');
    const [form] = Form.useForm();
    const {status} = useSession();
    const send = useNotification()
    const {push, replace} = useRouter();
    const [loading, setLoading] = useState(false)

    const onFinish = async (data) => {
        setLoading(true)
        const resp = await signIn('credentials',
            {
                ...data,
                redirect: false,
            }
        )

        if (resp.status !== 200) {
            if (isJsonString(resp.error)) {
                const er = JSON.parse(resp.error)
                if (er.status === 503) {
                    // await router.push('/503')
                } else {
                    send({
                        type: 'error',
                        description: tValid('wrong_credentials'),
                    })
                }
            } else {
                send({
                    type: 'error',
                    description: tValid('wrong_credentials'),
                })
            }
            setLoading(false)
        } else {
            await api.restAccessToken()
            const session = await getSession()
            if (session?.user?.is_admin) {
                replace(myLinks.getUlr('home'))
            } else {
                setLoading(false)
                send({
                    type: 'error',
                    description: tValid('access_denied'),
                })
            }
        }
    }

    useEffect(()=>{
        if (status === 'authenticated'){
            push('/')
        }
    }, [status])

    return(
        <>
            <div className={s.main_wrapper}>
                <div className={s.head_wrap}>
                    <div className={s.head_logo}><Logo /></div>
                    <LanguagesSwitch page={'auth'}/>
                </div>
                <div className={s.sign_up_content}>
                    <h2>{t('title')}</h2>
                    <div className={s.content}>
                        <div style={{width: '100%'}}>
                            <MyForm
                                spinning={loading}
                                form={form}
                                autoComplete="off"
                                layout={'vertical'}
                                name='sign-in'
                                style={{
                                    maxWidth: 514,
                                    width: '100%'
                                }}
                                onFinish={onFinish}
                            >

                                <Form.Item
                                    label={t('labels.email')}
                                    name="email"
                                    style={{ marginBottom: '12px' }}
                                    rules={[
                                        {
                                            required: true,
                                            message: t('validations.email'),
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder='Enter your email or username'
                                        className={s.field}
                                    />
                                </Form.Item>
                                <div className='mb-8'>
                                    <Form.Item
                                        label={t('labels.password')}
                                        name="password"
                                        style={{ marginBottom: 0 }}
                                        className={s.form_item}
                                        rules={[
                                            {
                                                required: true,
                                                message: t('validations.password'),
                                            },
                                        ]}
                                    >
                                        <Input.Password
                                            placeholder='Password'
                                            className={s.field}
                                        />
                                    </Form.Item>
                                    <div className={s.text_right}>
                                        <Link style={{color: '#DB3333'}} href={'/sign-in/forgot-password'}>{t('forgot')}</Link>
                                    </div>
                                </div>
                                <Button
                                    type="default"
                                    className={s.auth}
                                    style={{ maxWidth: '100%', width: '100%' }}
                                    htmlType="submit"
                                >
                                    {t('button_login')}
                                </Button>
                            </MyForm>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}